module.exports = __webpack_public_path__ + "img/info_btn.951dd775.png";